import React from 'react';
import { LoadingState, EmptyState, PublicadoresList } from '..';

const ModalContent = ({
  carregando,
  pontoSelecionado,
  currentPageItems,
  ultimasDesignacoes,
  limitesFrequencia,
  disponibilidadeSemana,
  ausenciasSelecionadas,
  selecionados,
  togglePublicador,
}) => {
  if (carregando) {
    return <LoadingState />;
  }

  if (!pontoSelecionado) {
    return <EmptyState message="Selecione um ponto" />;
  }

  return (
    <PublicadoresList
      publicadores={currentPageItems}
      ultimasDesignacoes={ultimasDesignacoes}
      limitesFrequencia={limitesFrequencia}
      disponibilidadeSemana={disponibilidadeSemana}
      ausenciasSelecionadas={ausenciasSelecionadas}
      selecionados={selecionados}
      togglePublicador={togglePublicador}
    />
  );
};

export default ModalContent;
